import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPhoneDisplay(phone: string | null | undefined, fallback = '-') {
  if (!phone) return fallback
  const digits = phone.replace(/\D/g, '')
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)} ${digits.slice(7)}`
  }
  if (digits.length === 10) {
    return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)} ${digits.slice(6)}`
  }
  return phone
}

export function formatPhoneInput(raw: string) {
  const digits = raw.replace(/\D/g, '')
  const d = digits.startsWith('1') && digits.length > 1 ? digits.slice(1) : digits
  if (d.length === 0) return ''
  let formatted = '+1 (' + d.slice(0, 3)
  if (d.length >= 3) formatted += ') ' + d.slice(3, 6)
  else return formatted
  if (d.length > 6) formatted += ' ' + d.slice(6, 10)
  return formatted
}

export function phoneToE164(formatted: string) {
  const digits = formatted.replace(/\D/g, '')
  if (digits.length === 11 && digits.startsWith('1')) return '+' + digits
  if (digits.length === 10) return '+1' + digits
  return '+' + digits
}

export function isValidE164(phone: string): boolean {
  return /^\+[1-9]\d{1,14}$/.test(phone)
}
